import React from 'react';
import MuiThemeProvider from '@mui/material/styles/ThemeProvider';
import { ThemeProvider } from 'styled-components';

import { useAppDispatch } from '../redux/hooks';
import * as URLS from '../constants/urls';
import * as api from '../utils/api';
import { getUserInfo } from '../utils/helpers';
import useToggleTheme from '../hooks/useToggleTheme';
import { themeDark, themeLight } from '../theme';
import { updateUserInfo } from './UserInfoSlice';

const MuiWrapper = ({ children }) => {
  const dispatch = useAppDispatch();
  const { isDarkMode } = useToggleTheme();
  const fetchAccountInfo = async () => {
    try {
      const { data } = await api.get(URLS.USER_ME);
      if (data) {
        dispatch(updateUserInfo(getUserInfo(data)));
      }
    } catch (error) {
      console.error(error);
    }
  };
  React.useEffect(() => {
    fetchAccountInfo();
  }, []);
  return (
    <MuiThemeProvider theme={isDarkMode ? themeDark : themeLight}>
      <ThemeProvider theme={isDarkMode ? themeDark : themeLight}>
        {children}
      </ThemeProvider>
    </MuiThemeProvider>
  );
};

export default MuiWrapper;
